import React from 'react';
import {
  SingleSelect,
  SingleSelectOption,
} from '@strapi/design-system/Select';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { CONTAINER_TYPE_OPTIONS } from '#shared/constants/containerType';

const ContainerTypeSelect = ({
  value,
  onChange,
  disabled = false,
  className,
  error,
  hint,
  labelAction,
  name,
  required = false,
}) => {
  const { enableContainerTypes } = useFlags();

  if (!enableContainerTypes) {
    return null;
  }

  return (
    <div className={className}>
      <SingleSelect
        disabled={disabled}
        error={error}
        hint={hint}
        label="Container Type"
        labelAction={labelAction}
        name={name}
        onChange={onChange}
        onClear={() => onChange(null)}
        placeholder="Select a container type"
        required={required}
        value={value || undefined}
        clearLabel="Clear container type"
      >
        {CONTAINER_TYPE_OPTIONS.map((option) => (
          <SingleSelectOption key={option.value} value={option.value}>
            {option.label}
          </SingleSelectOption>
        ))}
      </SingleSelect>
    </div>
  );
};

export default ContainerTypeSelect;
